export const segmentedControlSizes = {
  m: 'm',
  s: 's',
}

export const segmentedControlBorderRadiusesRem = {
  [segmentedControlSizes.m]: '1rem',
  [segmentedControlSizes.s]: '0.75rem',
}

export const segmentedControlBorderRadiusesPx = {
  [segmentedControlSizes.m]: '16px',
  [segmentedControlSizes.s]: '12px',
}

export const segmentedControlItemHeightRem = {
  [segmentedControlSizes.m]: '2.25rem',
  [segmentedControlSizes.s]: '1.5rem',
}

export const segmentedControlItemHeightPx = {
  [segmentedControlSizes.m]: '36px',
  [segmentedControlSizes.s]: '24px',
}

export const segmentedControlItemBorderRadiusesRem = {
  [segmentedControlSizes.m]: '0.75rem',
  [segmentedControlSizes.s]: '0.5rem',
}

export const segmentedControlItemBorderRadiusesPx = {
  [segmentedControlSizes.m]: '12px',
  [segmentedControlSizes.s]: '8px',
}

export const segmentedControlItemIconWrapperSizesRem = {
  [segmentedControlSizes.m]: '1.5rem',
  [segmentedControlSizes.s]: '1rem',
}

export const segmentedControlItemIconWrapperSizesPx = {
  [segmentedControlSizes.m]: '24px',
  [segmentedControlSizes.s]: '16px',
}

export const segmentedControlItemIconSizesRem = {
  [segmentedControlSizes.m]: '0.875rem',
  [segmentedControlSizes.s]: '0.625rem',
}

export const segmentedControlItemIconSizesPx = {
  [segmentedControlSizes.m]: '14px',
  [segmentedControlSizes.s]: '10px',
}
